<template>
  <section
    class="stores-steps-bonus"
    aria-label="Noch zwei Schritte bis zu deinem Cashback"
  >
    <GridContainer padding>
      <Paragraph
        align="center"
        class="stores-steps-bonus__lead"
      >
        Noch zwei kurze Schritte bis zu deinem Cashback
      </Paragraph>

      <div class="stores-steps-bonus__entry-cards">
        <Card
          v-for="(card, i) in entries"
          :key="i"
          v-bind="card"
          class="stores-steps-bonus__entry-card"
        />
      </div>
    </GridContainer>
  </section>
</template>

<script setup lang="ts">
import {
  GridContainer,
  Card,
  Paragraph,
  type CardComponentProps,
} from '@i22team/td-longtail-vue-components';

const entries: CardComponentProps[] = [
  {
    label: {
      text: 'Schritt 2',
      customClass: 'text--bold text--primary text--center text--uppercase',
    },
    heading: {
      tag: 'h3',
      size: 'sm',
      text: 'Handyrechnung im Store hinterlegen',
      spacesBottomRem: true,
    },
    text: 'Einmal im App Store oder Google Play die Handyrechnung als Zahlart aktivieren, dann ersten Kauf tätigen. Wie das geht, zeigen wir dir unten für iOS und Google Play.',
    image: {
      src: '/content/content-images/dcb/stores/bonus/1d1654e8158ca4464b17cb00927da690/mockup-aurora-step.png',
      aspectRatio: '1359 / 1895',
    },
    squareBadgeReverse: true,
    squareBadge: [
      {
        text: '#2',
        theme: 'magenta',
      },
    ],
    buttons: [
      {
        label: "So richtest du's ein",
        tag: 'button',
        type: 'button',
        variant: 'primary',
        onClick: () => {
          document.getElementById('wofuer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
      },
    ],
  },
  {
    label: {
      text: 'Schritt 3',
      customClass: 'text--bold text--primary text--center text--uppercase',
    },
    heading: {
      tag: 'h3',
      size: 'sm',
      text: '100 % Cashback kassieren',
      spacesBottomRem: true,
    },
    text: 'Der volle Betrag (bis 10&nbsp;€) erscheint als Gutschrift auf deiner Telekom Rechnung.',
    image: {
      src: '/content/content-images/dcb/stores/bonus/48d0af4be2c7fccd15cfc4621389865c/mockup-bill-step.png',
      aspectRatio: '1359 / 1895',
    },
    squareBadgeReverse: true,
    squareBadge: [
      {
        text: '#3',
        theme: 'magenta',
      },
    ],
  },
];
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.stores-steps-bonus {
  position: relative;
  padding-block: 2rem;

  @include mq($mq-md) {
    padding-block: 3rem;
  }

  &__lead {
    margin-bottom: 2rem;
    font-size: 1.375rem;
    color: var(--color-gray-600);
  }

  &__entry-cards {
    display: flex;
    justify-content: center;
    gap: 2rem;
    flex-direction: column;
    align-items: center;

    @include mq($mq-sm) {
      flex-direction: row;
      align-items: stretch;
    }
  }

  &__entry-card {
    --card-bg-color: #fff;
    border: 1px solid #e0e0e0;
    text-align: center;
    width: 100%;
    --card-image-container-height: 380px;
    --card-image-flex: 0 0 380px;
    --card-action-justify: center;

    @include mq($mq-md) {
      --card-image-container-height: 403px;
      --card-image-flex: 0 0 540px;
      flex: 0 1 408px;
    }
  }
}
</style>
